import { TUserProfileState } from './actions';
import { TRootState } from '../index';

export const userProfileState = (state: TRootState): TUserProfileState => state.userProfile.profile;
export const userProfileError = (state: TRootState): any => state.userProfile.error;
